import { Button, CircularProgress } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

interface SubmitButtonProps {
  isSubmitting: boolean
  onClick: () => void
  sx?: SxProps<Theme>
  children: React.ReactNode
}

export function SubmitButton({ isSubmitting, onClick, sx, children }: SubmitButtonProps) {
  return (
    <Button
      type="submit"
      variant="contained"
      onClick={isSubmitting ? undefined : onClick}
      sx={[{ minWidth: '80px' }, sx] as SxProps<Theme>}
    >
      {isSubmitting ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  )
}
